module.exports = __webpack_public_path__ + "static/media/anatomia.25737c40.png";